import { ITemplateScope } from "AngularFormly";
import { get, set } from "lodash";
import { File } from "../../../../server/crud";
import {
  RecordsUtilsService,
  vsName as RecordsUtilsServiceName,
} from "../../../../utils";

export interface RecordFileTemplateOptions {
  label?: string;
  allowMultiple?: boolean;
  required?: boolean;
  uploadText?: string;
  noFilesText?: string;
  url?: string;
  group?: string;
}

interface IRecordFileControllerScope extends ITemplateScope {
  getFiles: () => File[];
  getFileId: (file: File) => number;
  onFileUploadSuccess: (files: File[]) => void;
  remove: (file: File) => void;
}

export class RecordFileController {
  static $inject = ["$scope", RecordsUtilsServiceName];

  get templateOptions(): RecordFileTemplateOptions {
    return this.$scope.to;
  }

  constructor(
    private readonly $scope: IRecordFileControllerScope,
    private readonly recordUtils: RecordsUtilsService
  ) {
    this.initializeOptions(this.templateOptions);
    $scope.getFiles = () => this.getFiles();
    $scope.getFileId = (file) => this.getFileId(file);
    $scope.onFileUploadSuccess = (files) => this.onFileUploadSuccess(files);
    $scope.remove = (file) => this.remove(file);

    const allFiles = this.getAllFiles();
    if (allFiles.length === 0 && $scope.model !== undefined) {
      set($scope.model, $scope.options.key, []);
    }

    this.assignIdsToModel(allFiles);
  }

  private assignIdsToModel(values: any[]): any {
    values
      .filter((v) => !this.recordUtils.getRecordId(v))
      .forEach((v) => this.recordUtils.assignId(v));
  }

  remove(file: File) {
    const files = this.getAllFiles();
    const index = files.indexOf(file);
    if (index < 0) return;
    files.splice(index, 1);
  }

  private onFileUploadSuccess(files: File[]): void {
    const allFiles = this.getAllFiles();

    files.forEach((file) => {
      const existingFile = allFiles.find((f) => f.Url === file.Url);
      if (existingFile) return;

      this.recordUtils.assignId(file);
      if (this.templateOptions.group) {
        file.Group = this.templateOptions.group;
      }
      allFiles.splice(allFiles.length, 0, file);
    });
  }

  private getAllFiles(): File[] {
    return <File[]>get(this.$scope.model, this.$scope.options.key) ?? [];
  }

  private getFiles(): File[] {
    const files = this.getAllFiles();
    const group = this.templateOptions.group;

    return files.filter((f) => (group ? f.Group === group : true));
  }

  private getFileId(file: File): number {
    return this.recordUtils.getRecordId(file) ?? 0;
  }

  private initializeOptions(templateOptions: RecordFileTemplateOptions) {
    templateOptions.label = templateOptions.label ?? "Files";
    templateOptions.label = templateOptions.label ?? "Files";
    templateOptions.allowMultiple = templateOptions.allowMultiple ?? false;
    templateOptions.required = templateOptions.required ?? false;
    templateOptions.uploadText = templateOptions.uploadText ?? "Choose files";
    templateOptions.noFilesText = templateOptions.noFilesText ?? "No Files";
    templateOptions.url = templateOptions.url ?? "/api/files";
  }
}
